module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_camera_c69084680840fff1f701ab049df6a76e.png";